/**
 * Shared chart palette for the composer dashboard.
 *
 * `CHART_COLORS` is the in-tone primary palette (chart-1..10) used by every
 * by-X chart so they read as one visual family. `OTHER_COLOR` is a muted
 * gray used as a last-bucket fill, keeping it visually subordinate to the
 * named slices.
 */
export const CHART_COLORS = [
  'var(--chart-1)',
  'var(--chart-2)',
  'var(--chart-3)',
  'var(--chart-4)',
  'var(--chart-5)',
  'var(--chart-6)',
  'var(--chart-7)',
  'var(--chart-8)',
  'var(--chart-9)',
  'var(--chart-10)',
];

export const OTHER_COLOR = 'var(--muted-foreground)';

const modelColorMap = new Map<string, string>();

export function getModelColor(name: string): string {
  if (name === 'Other') return OTHER_COLOR;

  const existing = modelColorMap.get(name);
  if (existing) return existing;

  const color = CHART_COLORS[modelColorMap.size % CHART_COLORS.length];
  modelColorMap.set(name, color);
  return color;
}

/**
 * Pick a chart-palette color by index. Use this for charts where slice
 * order (biggest → smallest) drives color assignment so the largest
 * segment always lands on chart-1, the next on chart-2, etc. — matching
 * the tone of the "Token Usage by Model" + "Output Deliverable" charts.
 */
export function getChartPaletteColor(index: number): string {
  return CHART_COLORS[index % CHART_COLORS.length];
}

export function cleanModelName(raw: string): string {
  return raw
    .replace(/^.*\//, '')
    .replace(/^claude-/, '')
    .replace(/-\d{4}-\d{2}-\d{2}$/, '')
    .replace(/-\d{8}$/, '')
    .replace(/-latest$/, '');
}
